class ParallaxElement extends HTMLElement {
  constructor() {
    super()
    this.speed = 0.12
    this.initialOffset = -80
    this.onScroll = this.applyParallaxEffect.bind(this)
    this.threshold = 0.1
    this.applyInitialOffset = this.applyInitialOffset.bind(this)
  }

  connectedCallback() {
    if (window.innerWidth < 1100 && window.innerWidth > 768) {
      this.speed = 0.04
      this.initialOffset = -30
      this.threshold = 0.15
    } else if (window.innerWidth < 1500) {
      this.speed = 0.04
      this.initialOffset = -30
      this.threshold = 0.05
    }

    // Create an intersection observer to trigger the parallax effect when the element is in view
    const intersectionObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // If the element is in view, add the scroll event listener
            window.addEventListener('scroll', this.onScroll)
          } else {
            // If the element is out of view, remove the scroll event listener
            window.removeEventListener('scroll', this.onScroll)
          }
        })
      },
      {
        threshold: this.threshold, // Trigger when at least 10% of the element is in view
      }
    )

    intersectionObserver.observe(this)
    // window.addEventListener('load', this.applyInitialOffset)
  }

  applyInitialOffset() {
    const parallaxChild = this.querySelector('.parallax-bg__wrapper')
    if (parallaxChild) {
      // Wait until the page is loaded and then set the initial transform
      parallaxChild.style.transform = `translateY(${this.initialOffset}px) scale(1) translateZ(0px)`
    }
    // Remove the load event listener after it's done
    window.removeEventListener('load', this.applyInitialOffset)
  }

  applyParallaxEffect() {
    const rect = this.getBoundingClientRect()
    let offset = rect.top * this.speed
    const parallaxChild = this.querySelector('.parallax-bg__wrapper')
    const scaleImg = this.querySelector('.scale-img')
    let scale = 1
    offset += this.initialOffset

    //   if (rect.top > 0) {
    //     offset = Math.max(offset, 0); // Prevent going back to negative (keep it smooth and prevent jumpiness)
    //   }

    if (parallaxChild) {
      // Apply the parallax effect (move the child background element)
      if (scaleImg) {
        scale = Math.min(1.1, 1 + (1 - rect.top / window.innerHeight) * 0.1)
      }

      parallaxChild.style.transform = `translateY(${-offset}px) scale(${scale}) translateZ(0px)`
    }
  }
}

export default ParallaxElement
